export default __webpack_public_path__ + "static/icon-4-4-4fa6ff6ab7c8631a7d445c244f022da1.png";